import styled from 'styled-components'
import { Arrow } from  '../../assets'
import { ellipsis } from 'polished'

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 230px;
  cursor: pointer;
  padding: 13px 10px 10px 10px;
  border: solid 1px #f4f6f6;
  transition: all .5s ease;
  box-sizing: border-box;
  color: #112426;

  @media (min-width: 768px) { 
    padding: 13px 13px 0 13px;
    height: 267px;
    border: solid 1px transparent;

    &:hover {
      border: solid 1px #f4f6f6;

      .title {
        transform: translateY(10px);
      }

      .arrow {
        opacity: 1;
        background-position: 0px 0px;
      }

      .description {
        opacity: 1;
      }

      .image {
        height: 130px;
        background-size: 100%;
      }

      .image-icon {
        mask-position: center 20px;
      }

      .text-enter {
        top: 102px;
      }
    }
  }
`

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 228px;
  background: url(${p => p.src}) no-repeat center center, #AEDBD9;
  background-size: 110%;
  transition: all .3s ease-in-out; 

  @media (min-width: 768px) { 
    height: 172px;
  }

  &:after {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #294745;
    opacity: .6;
    transition: all .3s ease-in-out; 
  }
`

export const TitleContainer = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  padding: 0 20px;

  .title-component {
    /* ${ellipsis(p => (p.width - 20) + "px")} */
  }

  @media (min-width: 768px) {
    padding: 0;
  }
`
export const DescriptionContainer = styled.div`
  position: relative;
  display: flex; 
  width: 100%;
  min-height: 40px;

  .description {
    margin-top: 6px !important;
    ${ellipsis(p => p.width + "px", 8)}
  }
`

export const ArrowLeft = styled.div`
  position: absolute;
  top: 38px;
  right: -16px;
  width: 40px;
  min-height: 20px;
  background: url(${Arrow}) no-repeat;
  background-position: 0px 0px;
  transition: all .3s ease-in-out;
  transform: scale(.7);
  z-index: 0;

  @media (min-width: 768px) {
    top: 16px;
  }
`

export const ImageIcon360Container = styled.div`
  position: absolute;
  box-sizing: border-box;
  top: 0;
  left: 0;
  height: 170px;
  width: 100%;
  z-index: 2;
  mask: url(${p => p.mask}) no-repeat;
  mask-position: center 50px;
  background: #FFF;
  transition: all .3s ease-in-out; 
`

export const Text360 = styled.p`
    position: absolute;
    width: 100%;
    top: 132px;
    left: 0;
    color: #FFF;
    font-size: 20px;
    letter-spacing: 1.2px;
    font-weight: lighter;
    z-index: 3;
    font-style: italic;
    text-align: center;
    transition: all .3s ease-in-out;

    @media (min-width: 768px) and (max-height: 700px){
      font-size: 18px;
    }
`